import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import {
	ResampleRequestBody,
	ResampleRequestBodyDates,
	ResampleResponsePayload,
} from '@Services/device';
import { ResampleJobRequest } from '@Types/sensorResample';

export const resampleSensor = createAction<ResampleRequestBody>(
	addNamespace('device/resample'),
);
export const resampleSensorResolved = createAction<ResampleResponsePayload>(
	addNamespace('device/resample/resolved'),
);
export const resampleSensorRejected = createAction(
	addNamespace('device/resample/rejected'),
);

export const resampleSensorJob = createAction<ResampleJobRequest>(
	addNamespace('device/resample/job'),
);
export const resampleSensorJobResolved = createAction(
	addNamespace('device/resample/job/resolved'),
);
export const resampleSensorJobRejected = createAction(
	addNamespace('device/resample/job/rejected'),
);

export const resampleAllSensors = createAction<ResampleRequestBodyDates>(
	addNamespace('device/resampleAll'),
);
export const resampleAllSensorsResolved = createAction<ResampleResponsePayload>(
	addNamespace('device/resampleAll/resolved'),
);
export const resampleAllSensorsRejected = createAction(
	addNamespace('device/resampleAll/rejected'),
);
